var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13217_120274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.98855 1.09081C9.1926 0.29482 7.86295 0.446526 7.26672 1.40136L5.68945 3.92736L6.53236 4.7703C6.55488 4.74076 6.57635 4.70976 6.59665 4.67727L8.25635 2.01929C8.45509 1.70101 8.89831 1.65044 9.16361 1.91577L12.0384 4.7906C12.3037 5.05593 12.2532 5.49914 11.9349 5.69787L9.27695 7.3576C9.24446 7.3779 9.21342 7.39931 9.18391 7.42182L10.0268 8.26474L12.5528 6.68746C13.5077 6.09124 13.6594 4.76163 12.8634 3.96564L9.98855 1.09081Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08022 5.16378C2.10137 4.82177 2.2461 4.48326 2.52564 4.24316L3.37061 5.08813C3.35923 5.09218 3.34786 5.09634 3.33649 5.10062C3.2935 5.11681 3.27798 5.13486 3.27035 5.14592C3.26061 5.16006 3.24762 5.18786 3.24466 5.23577C3.23826 5.33931 3.28391 5.4872 3.40043 5.60372L8.35015 10.5535C8.4667 10.67 8.61457 10.7156 8.71812 10.7092C8.76601 10.7063 8.79383 10.6933 8.80795 10.6836C8.81903 10.6759 8.83706 10.6604 8.85327 10.6174C8.85753 10.606 8.86173 10.5947 8.86576 10.5833L9.71072 11.4282C9.47062 11.7078 9.13211 11.8525 8.7901 11.8737C8.33358 11.9019 7.86429 11.7175 7.5252 11.3784L5.46281 9.31599L1.56612 13.2127C1.33832 13.4405 0.96897 13.4405 0.741167 13.2127C0.513361 12.9849 0.513361 12.6156 0.741167 12.3877L4.63785 8.49104L2.57547 6.42867C2.23637 6.08958 2.052 5.6203 2.08022 5.16378Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17086 1.17086C0.943048 1.39866 0.943048 1.76801 1.17086 1.99581L12.0082 12.8332C12.236 13.061 12.6054 13.061 12.8332 12.8332C13.061 12.6054 13.061 12.236 12.8332 12.0082L1.99581 1.17086C1.76801 0.943048 1.39866 0.943048 1.17086 1.17086Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13217_120274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.ca345fc6faa60cbfc2a7fa673392a077.svg";
export { ForwardRef as ReactComponent };